module.exports = __webpack_public_path__ + "img/you@3x.85c8a846.png";